/**
 * The settings area's route map.
 *
 * Exported as data rather than self-registering on import so the app entry
 * decides when the routes exist — three screen areas can then be wired in one
 * place without anyone editing `main.tsx` for each of them:
 *
 *     import { settingsRoutes } from "./screens/settings/routes.ts";
 *     registerRoutes(settingsRoutes);
 */

import type { Screen } from "../../main.tsx";

import { Aspects } from "./Aspects.tsx";
import { Profiles } from "./Profiles.tsx";
import { Settings } from "./Settings.tsx";
import { SyncStatus } from "./SyncStatus.tsx";

export const settingsRoutes: Record<string, Screen> = {
  "/settings": Settings,
  "/settings/aspects": Aspects,
  "/settings/profiles": Profiles,
  "/settings/sync": SyncStatus,
};
